import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { num_word } from 'vpl.tas';


export const CatalogSections = {
    components: {
        ItemEditBtns
    },
    data(){
        return {
            activeTab: ''
        }
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        num_word: num_word,
        changeType(id){
            this.activeTab = id;
        },
        showMoreType(event){
            event.preventDefault();
            let btn = $(event.target);
            if (!btn.hasClass('is-show')) {
                btn.addClass('is-show');
                btn.text('Свернуть');
                btn.closest('.js-catalog-section-list-wp').find('.js-catalog-section-list').addClass('is-show');
            } else {
                btn.removeClass('is-show');
                btn.text('Развернуть');
                btn.closest('.js-catalog-section-list-wp').find('.js-catalog-section-list').removeClass('is-show');
            }
        },
        showMore(event){
            event.preventDefault();
            let btn = $(event.target),
                list = btn.closest('.catalog-section__prim-wp').find('.js-catalog-section-links-list');

            if (!btn.hasClass('is-show')) {
                btn.addClass('is-show');
                btn.text('Свернуть');
                list.addClass('is-show');
              } else {
                btn.removeClass('is-show');
                btn.text('Показать ещё');
                list.removeClass('is-show');
                $('html').animate({
                  scrollTop: list.offset().top - 150
                }, 500);
              }
        }
    },
    updated(){

    },
    mounted(){

        if(this.struct[this.structKey].componentData.CHESS_ITEMS){
            this.activeTab = this.struct[this.structKey].componentData.CHESS_ITEMS[0].ID;
        }


        if ($(window).width() < 768) {
            if ($(this.$el).find('.js-catalog-section-links-item').length > 6) {
                $(this.$el).find('.js-catalog-section-links-btn').addClass('is-active');
            } else {
                $(this.$el).find('.js-catalog-section-links-btn').removeClass('is-active');
            }
        }

        $(this.$el).find('.js-catalog-section-list').each(function () {
            if ($(window).width() < 768) {
              if ($(this).find('.js-catalog-section-list-item').length > 6) {
                $(this).closest('.js-catalog-section-list-wp').find('.js-catalog-section-show').addClass('is-active');
              } else {
                $(this).closest('.js-catalog-section-list-wp').find('.js-catalog-section-show').removeClass('is-active');
              }
            } else {
              if ($(this).find('.js-catalog-section-list-item').length > 12) {
                $(this).closest('.js-catalog-section-list-wp').find('.js-catalog-section-show').addClass('is-active');
              } else {
                $(this).closest('.js-catalog-section-list-wp').find('.js-catalog-section-show').removeClass('is-active');
              }
            }
        });



    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH']),
        itemsHeader() {
            let header = '';
            for(let i in this.struct[this.structKey].componentData.CHESS_ITEMS){
                if(this.struct[this.structKey].componentData.CHESS_ITEMS[i].ID == this.activeTab){
                    header = this.struct[this.structKey].componentData.CHESS_ITEMS[i].NAME;
                }
            }
            return header.toLowerCase();
        },
    },
    template: `
<div v-if="this.struct[this.structKey].componentData.ITEMS" style="display: contents;">




    <section class="section section--first sections-banner">
        <div class="sections-banner__bg">
            <picture>
                <source type="image/avif" media="(max-width: 768px)" :srcset="this.SITE_TEMPLATE_PATH + '/img/content/catalog-section-banner-mob2.avif'">
                <source type="image/webp" media="(max-width: 768px)" :srcset="this.SITE_TEMPLATE_PATH + '/img/content/catalog-section-banner-mob2.webp'">
                <source media="(max-width: 768px)" :srcset="this.SITE_TEMPLATE_PATH + '/img/content/catalog-section-banner-mob2.jpg'">
                <source type="image/avif" :srcset="this.SITE_TEMPLATE_PATH + '/img/content/catalog-sections-banner.avif'">
                <source type="image/webp" :srcset="this.SITE_TEMPLATE_PATH + '/img/content/catalog-sections-banner.webp'">
                <img :src="this.SITE_TEMPLATE_PATH + '/img/content/catalog-sections-banner.jpg'" alt="Каталог оборудования"
                    title="Каталог оборудования">
            </picture>

        </div>
        <div class="container">
            <div class="sections-banner__main">
                <h3 class="sections-banner__main-title">
                    Более 20 000 позиций оборудования для профессиональной кухни баров, ресторанов и столовых
                </h3>
                <a href="#" data-toggle="modal" data-target="#contactUs" class="btn btn--green">Консультация</a>
            </div>
        </div>
    </section>

    <section class="sections-head catalog-section--gray">
        <div class="container">
            <div class="sections-head__wp">
                <h2 class="sections-head__title js-section-title">
                    Оборудование {{itemsHeader}}
                </h2>
                <div class="sections-head__selector">
                    <div v-for="item in this.struct[this.structKey].componentData.CHESS_ITEMS"
                        @click="changeType(item.ID)"
                        class="sections-head__selector-item js-catalog-selector-item"
                        :class="{'is-active': this.activeTab == item.ID}"
                        :data-title="item.NAME">
                        {{item.NAME}}
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="catalog-section__tabs">

        <div v-for="item in this.struct[this.structKey].componentData.CHESS_ITEMS"
             class="catalog-section__tabs-item js-catalog-tab-item "
             :class="{'is-active': this.activeTab == item.ID}"
             >

            <section

                class="section section--smallpadding catalog-section catalog-section--gray"

                >
                <div class="container">
                    <div class="catalog-section__type" v-for="(groupItems, key) in item.SUBSECTIONS">
                        <template v-for="subItem in groupItems">

                            <div v-if="subItem.BANNER" class="catalog-section__type-banner">
                                <h3 class="catalog-section__type-banner-title">
                                    {{subItem.NAME}}
                                </h3>
                                <a href="#" data-toggle="modal" data-target="#contactUs" class="btn btn--green">{{subItem.BUTTON}}</a>
                                <div v-if="subItem.PICTURE" class="catalog-section__type-banner-img">
                                    <img class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="subItem.PICTURE" :alt="subItem.NAME" :title="subItem.NAME">
                                </div>
                            </div>

                            <div v-else class="catalog-section__type-item js-catalog-section-list-wp">

                                <div class="catalog-section__type-item-heading">

                                    <a :href="subItem.LINK" class="catalog-section__type-title">
                                        <div class="catalog-section__type-icon">
                                            <img class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="subItem.ICON" :alt="subItem.NAME" :title="subItem.NAME">
                                            <img class="hover lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="(subItem.ICON_H !== false ? subItem.ICON_H : subItem.ICON)" :alt="subItem.NAME" :title="subItem.NAME">
                                        </div>
                                        {{subItem.NAME}}
                                    </a>

                                    <div class="catalog-section__type-amount">{{subItem.COUNT}} {{this.num_word(subItem.COUNT, ['модель', 'модели', 'моделей'])}}</div>
                                </div>

                                <ul v-if="subItem.SUBSECTIONS && Object.keys(subItem.SUBSECTIONS).length" class="catalog-section__type-item-list js-catalog-section-list">

                                    <li v-for="subSubItem in subItem.SUBSECTIONS" class="js-catalog-section-list-item">
                                        <a :href="subSubItem.LINK" class="catalog-section__type-item-link">{{subSubItem.NAME}}</a>
                                    </li>

                                </ul>
                                <a href="#" class="btn btn--gray js-catalog-section-show" @click.prevent="showMoreType($event)">
                                    Развернуть
                                </a>
                            </div>

                        </template>
                    </div>
                </div>
            </section>
        </div>

    </div>
    <section v-if="this.struct[this.structKey].componentData.IBLOCK_DESCRIPTION" class="section">
        <div class="container" v-html="this.struct[this.structKey].componentData.IBLOCK_DESCRIPTION">
        </div>
    </section>
</div>
    `
}